import { OrderRepository } from '../repositories/order-repository';
import { Order } from '../entities/order-entity';

interface OrderUsecase {
  GetOrders(client_id: string): Promise<Order[]>;
  TerminateOrder(client_id: string, order_id: string, trip_id: string): Promise<Order>;
}

export class OrderUsecaseImpl implements OrderUsecase {
  orderRepository: OrderRepository;

  constructor(or: OrderRepository) {
    this.orderRepository = or;
  }

  GetOrders(client_id: string): Promise<Order[]> {
    return this.orderRepository.GetOrders(client_id);
  }

  TerminateOrder(client_id: string, order_id: string, trip_id: string): Promise<any> {
    return this.orderRepository.TerminateOrder(client_id, order_id, trip_id);
  }
}
